import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import { defaultFilters } from "@dealer-center/ddc-pages-account-search-interface";
import { useEffect, useState } from "react";
import { useLocalStorageHook } from "@dealer-center/core-components";
import { useLocalStorageKeys } from "@dealer-center/core-interfaces-components";
import { AccountSearchContext } from "./AccountSearchContext";
import { useAccountSearchGet } from "@dealer-center/ddc-pages-account-search-fetch";

const hasSearchChanged = (newSearchRequest: dealerSearchIncoming) => {
  const defaultFiltersString = JSON.stringify(defaultFilters);
  const newSearchRequestString = JSON.stringify(newSearchRequest);
  const searchChanged = defaultFiltersString !== newSearchRequestString;
  return searchChanged;
};

export const AccountSearchProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [searchRequest, setSearchRequest] =
    useState<dealerSearchIncoming>(defaultFilters);
  const [newSearchRequest, setNewSearchRequest] = useState<
    Partial<dealerSearchIncoming> | undefined
  >(defaultFilters);
  useEffect(() => {
    const mergedNewSearchRequest = {
      ...searchRequest,
      ...newSearchRequest
    };
    const _isSearchDefault = !hasSearchChanged(mergedNewSearchRequest);
    const searchRequestToSet = _isSearchDefault
      ? defaultFilters
      : mergedNewSearchRequest;
    setSearchRequest(searchRequestToSet);

    setIsSearchDefault(_isSearchDefault);
  }, [newSearchRequest]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useLocalStorageHook(
    useLocalStorageKeys.ddcPagesClientSearchPageSize,
    10
  );
  const [isSearchDefault, setIsSearchDefault] = useState(true);

  const accountSearchGet = useAccountSearchGet({
    page,
    size,
    searchRequest,
    disabled: isSearchDefault
  });
  const updatePage = (newPage: number) => {
    setPage(newPage);
  };
  const updateSize = (newSize: number) => {
    updatePage(0);
    setSize(newSize);
  };
  return (
    <AccountSearchContext.Provider
      value={{
        page,
        size,
        updatePage,
        updateSize,
        updateSearchRequest: setNewSearchRequest,
        searchRequest,
        isSearchDefault,
        accountSearchGet
      }}
    >
      {children}
    </AccountSearchContext.Provider>
  );
};
